import React from "react";
import { Event } from "@uno/protocol";
import { Socket } from "socket.io-client";
import useLocalStorage from "./useLocalStorage";

const USER_IDENTITY_STORAGE_KEY = "LASTDOTCARDS.USER_IDENTITY";

const useAuth = (socket: Socket | null, setToken: React.Dispatch<React.SetStateAction<string | null>>) => {
    const [storedToken, setStoredToken] = useLocalStorage(USER_IDENTITY_STORAGE_KEY);
    const [isAuthReady, setIsAuthReady] = React.useState(false);
    const clearSession = React.useCallback(() => {
        localStorage.removeItem(USER_IDENTITY_STORAGE_KEY);
        setToken(null);
    }, [setToken]);

    React.useEffect(() => {
        setToken(storedToken);
        setIsAuthReady(true);
    }, []);

    React.useEffect(() => {
        const onHandshake = (data: { token?: string }) => {
            if(data.token) {
                setStoredToken(data.token);
                setToken(data.token);
            }
        };

        socket?.on(Event.Handshake, onHandshake);

        return () => {
            socket?.off(Event.Handshake, onHandshake);
        };
    }, [socket]);

    return { isAuthReady, clearSession };
};

export default useAuth;
